import { useEffect } from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@fontsource-variable/noto-sans-arabic";
import "./styles/tokens.css";
import "./index.scss";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals.ts";
import { ThemeProvider } from "./contexts/ThemeContext.tsx";
import { registerServiceWorker } from "./registerServiceWorker.ts";
import { API_HOST, IS_WHITE_LABEL } from "./constants";

const isSentryDisabled = import.meta.env.VITE_APP_DISABLE_SENTRY === "true";

function Monitoring() {
  useEffect(() => {
    if (IS_WHITE_LABEL || isSentryDisabled || window.location.hostname === "localhost") return;
    Sentry.init({
      dsn: import.meta.env.VITE_APP_SENTRY_DSN || "https://ee9161b44e9c5e472182e3c107d13b78@o477497.ingest.sentry.io/4506469108088832",
      integrations: [
        new Sentry.BrowserTracing({ tracePropagationTargets: [window.location.origin, API_HOST] }),
        new Sentry.Replay({ networkDetailAllowUrls: [API_HOST], maskAllText: false, blockAllMedia: false }),
      ],
      tracesSampleRate: 0.5,
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
    });
  }, []);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <ThemeProvider>
    <Monitoring />
    <App />
  </ThemeProvider>
);

reportWebVitals();
registerServiceWorker();
